/** HTML 可视化编辑引擎标识。 */
export const HTML_EDITOR_ENGINE = 5;
/** 云文档 HTML 文件类型标识。 */
export const HTML_FILE_TYPE = 13;
/** HTML 文件扩展名白名单。 */
export const HTML_FILE_EXTENSIONS = Object.freeze(['html', 'htm']);

/**
 * 获取文件扩展名，不包含点号且统一为小写。
 * @param {object|null|undefined} file - 文件信息
 * @returns {string} 文件扩展名
 */
export function getHtmlFileExtension(file) {
  const rawExtension = String(file?.ext || file?.extension || '');
  const explicitExtension = rawExtension.startsWith('.') ? rawExtension.slice(1) : rawExtension;
  // 后端已返回扩展名时优先使用，避免文件名包含多个点导致歧义。
  if (explicitExtension) return explicitExtension.toLowerCase();
  const fileName = String(file?.name || file?.fileName || '');
  const dotIndex = fileName.lastIndexOf('.');
  // 文件名无有效后缀时返回空串。
  if (dotIndex < 0 || dotIndex === fileName.length - 1) return '';
  return fileName.slice(dotIndex + 1).toLowerCase();
}

/**
 * 统一判断文件是否为 HTML 可视化文档。
 * editorEngine 一旦明确给出，以其为唯一权威，避免 .html 后缀抢走轻文档等其它引擎。
 * 仅当 editorEngine 缺失时，才回退 fileType=13 / html|htm 扩展名（历史节点兼容）。
 * @param {object|null|undefined} file - 文件信息
 * @returns {boolean} 是否为 HTML 文件
 */
export function isHtmlDocumentFile(file) {
  const engine = Number(file?.editorEngine);
  // 后端已写入引擎类型时不再用后缀兜底，防止 engine=2 的 *.html 误进 HTML 分支。
  if (Number.isFinite(engine) && engine > 0) {
    return engine === HTML_EDITOR_ENGINE;
  }
  // 历史节点可能只有 fileType 或扩展名，没有 editorEngine。
  if (Number(file?.fileType) === HTML_FILE_TYPE) return true;
  return HTML_FILE_EXTENSIONS.includes(getHtmlFileExtension(file));
}
